
import { AppFolder24Filled, AppFolder24Regular, bundleIcon } from "@fluentui/react-icons";

export const AppIcon = bundleIcon(AppFolder24Filled, AppFolder24Regular);